
import Backbone from 'backbone';

import Folder from './folder.js';



const FolderCollection = Backbone.Collection.extend({

  model: Folder,

  url: '/api/page_folders',


});



export default FolderCollection;

